import './styled.scss';
import { exhbtListContent } from 'data/exhbt';
import styled from 'styled-components';

const ItemContainer = styled.div`
  margin-bottom: 45px;
`;

const VimeoContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 58%;
  overflow: hidden;
  max-width: 100%;
  background: black;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

/**
 * 사이버 주택전시관 컴포넌트
 */
const Exhbt = () => {
  /**
   * 클릭 시 이동할 URL
   * @param path URL 정보
   */
  const handleClickMovePage = (path: string, type: string) => {
    // 팝업 또는 페이지를 이동시키는 함수
    if (type === 'vr') {
      window.open(path, '_blank');
    }
  };

  return (
    <div className="contents-exhbt-mobile">
      <div className="container t-center">
        <i className="ico-double-dot"></i>
        <h3 className="h-title">살수록 커지는 차이와 가치</h3>
        <p className="txt-desc-medium02">e편한세상 시티 도안에서 생활의 차이는 커지고<br/> 내일의 가치는 더 커집니다.</p>
      </div>

      <div className="container pt-30">
        <h3 className="h-title medium01">관람하기</h3>
        {exhbtListContent &&
          exhbtListContent.map((item, index) => {
            if (item.type === 'vr') {
              return (
                <ItemContainer
                  key={index}
                  className="content-01 mt-20"
                  onClick={e => handleClickMovePage(item.mobile, item.type)}>
                  <div className="area-img">
                    <img src={item.img} alt="" />
                    <i className="ico-play"></i>
                  </div>
                  <div className="txt-area">
                    <p className="tit">{item.tit}</p>
                    <p className="desc pt-10">{item.subtit}</p>
                  </div>
                </ItemContainer>
              );
            } else {
              return (
                <ItemContainer>
                  <VimeoContainer>
                    <iframe src={item.mobile} width={`100%`} height={`100%`} title="사이버 주택 전시관" allowFullScreen />
                  </VimeoContainer>
                  <div className="txt-area">
                    <p className="tit">{item.tit}</p>
                    <p className="desc pt-10">{item.subtit}</p>
                  </div>
                </ItemContainer>
              );
            }
          })}
      </div>
    </div>
  );
};

export default Exhbt;
